// @flow
import React, { Fragment } from 'react';
import Slider from 'react-slick';
import cx from 'classnames';
import EventCard from 'components/common/EventCard';
import type { EventItem } from 'store/modules/eventing';
import FakeEventCard from 'components/common/FakeEventCard';
import './EventCardList.scss';
import ArrowLeft from '../Arrow/ArrowLeft';
import ArrowRight from '../Arrow/ArrowRight';
import FakeBannerCard from '../FakeBannerCard';

type Props = {
  events?: ?(EventItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 4;
  if (width < large) return 6;
  if (width < xLarge) return 6;
  if (width < wide) return 6;
  if (width < xWide) return 12;
  return 12;
};

const getTrendingCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 4;

  if (width < medium) return 4;
  if (width <= large) return 6;
  if (width <= xLarge) return 6;
  if (width <= wide) return 8;
  if (width <= xWide) return 10;
  return 12;
};

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <ArrowLeft
      classname={className}
      click={onClick}
      background={'rgba(0,0,0,.15)'}
      width={25}
      height={25}
      color={'white'}
    />
  );
}

function NextArrow(props) {
  const { className, onClick } = props;

  return (
    <ArrowRight
      classname={className}
      click={onClick}
      background={'rgba(0,0,0,.15)'}
      width={25}
      height={25}
      color={'white'}
    />
  );
}

const EventCardList = ({
  events,
  loading,
  prefetching,
  width,
  hasEnded,
  oneColumn,
  isTrending,
}: Props) => {
  const trendingCount = getTrendingCount(width);
  if (loading) {
    return (
      <div className="EventCardList">
        {createArray(trendingCount).map(num => (
          <FakeEventCard key={num} oneColumn={oneColumn} />
        ))}
      </div>
    );
  }
  const settings = {
    dots: width <= 768,
    infinite: true,
    speed: 800,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: width >= 768 ? 2 : 1,
    slidesToScroll: width >= 768 ? 2 : 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const columnCount = oneColumn ? 1 : getColumnCount(width);
  if (!events) return null;
  const TrendingList = isTrending ? events.slice(0, trendingCount) : events;
  const eventList = (hasEnded || events.length <= 10
    ? TrendingList
    : events.slice(0, events.length - (events.length % columnCount))
  ).map(event => (
    <EventCard
      key={event.id}
      id={event.id}
      thumbnail={event.thumbnail}
      title={event.title}
      body={event.meta && event.meta.short_description}
      urlSlug={event.url_slug}
      oneColumn={oneColumn}
      shortDescription={event.meta.short_description}
      eventAt={event.meta.eventAt}
      eventStatus={event.meta.eventStatus}
      isTrending={isTrending}
    />
  ));

  const fakeEventList = createArray(columnCount).map(num => (
    <FakeEventCard key={num} oneColumn={oneColumn} />
  ));

  return (
    <Fragment>
      <div className={cx('EventCardList', { 'is-trending': !isTrending })}>
        {isTrending ? (
          <Slider {...settings}>
            {eventList && eventList.length === 0 && (
              <div className="empty-list">아직 등록된 이벤트가 없습니다.</div>
            )}
            {eventList}
            {prefetching && fakeEventList}
          </Slider>
        ) : (
          <Fragment>
            {eventList && eventList.length === 0 && (
              <div className="empty-list">아직 등록된 이벤트가 없습니다.</div>
            )}
            {eventList}
            {prefetching && fakeEventList}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

EventCardList.defaultProps = {
  events: [],
  oneColumn: false,
  width: 1600,
  placeholderCount: 12,
  hideUsername: false,
};

export default EventCardList;



// WEBPACK FOOTER //
// ./src/components/common/EventCardList/EventCardList.js